import { generateApiPath } from "@routes/generatePath";

const pathBase = `/reports/system-accounting-export`;

export const systemAccounting = {
  get: () => generateApiPath(pathBase),
};
